import React, { useEffect, useState, useRef } from 'react';
import { Player } from 'video-react';
import { Link } from 'react-router-dom';
import 'video-react/dist/video-react.css'; // import css
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';
// import _ from 'lodash';
import cn from 'classnames';
import './CallPreviewPanel.scss';
import Close from '@material-ui/icons/Close';
import Loader from '../General/Loader';

import { getCall } from '../../api/calls';

import { getPrettyTimeDisplayFromTimestamp, getSecondsFromTimestamp } from '../../helpers/formatting';

const CallPreviewPanel = (props) => {
  const { closePanel } = props;
  const { id } = props.call || {};
  const [call, setCall] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      getCall(id)
        .then((resp) => {
          setIsLoading(false);
          setCall(resp);
        })
        .catch((error) => {
          cogoToast.error(`There was an error loading this chat, please try again.`);
          setTimeout(closePanel, 300);
        });
    } else {
      setCall(null);
    }
  }, [id, closePanel, setIsLoading]);

  const video_s3_url = call?.recording?.video_s3_url;
  const time_partition_summary = call?.summary?.time_partition_summary;
  return (
    <div className={cn('call-preview-panel-outer-container', { visible: call })}>
      <div className='call-preview-panel-inner-container'>
        {isLoading ? (
          <div className='loading-call'>
            <Loader size={75} />
          </div>
        ) : (
          <>
            {video_s3_url && (
              <Player ref={videoRef} onReady={() => console.log('ready')} muted>
                {/* <ControlBar disableCompletely /> */}
                <source src={video_s3_url} />
              </Player>
            )}
            <div className='content'>
              <h1 className='call-name'>{call?.chat_name}</h1>
              <Link to={`/calls/${call?.id || id}`} className='see-full-analysis'>
                See Full Analysis
              </Link>
              {time_partition_summary ? (
                <div className='partition-rows'>
                  {time_partition_summary.times.map((timestamps, idx) => {
                    const [start] = timestamps;
                    const content = time_partition_summary.summary[idx];
                    const navigateToTimestamp = () => {
                      videoRef.current && videoRef.current.seek(getSecondsFromTimestamp(start));
                      videoRef.current && videoRef.current.play();
                    };
                    return (
                      <div key={idx} onClick={navigateToTimestamp} className='partition-row'>
                        <div className='partition-timestamp'>{getPrettyTimeDisplayFromTimestamp(start)}</div>
                        <div className='partition-content'>{content}</div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className='empty-partition'>No Time Partition Summary Available</div>
              )}
            </div>
          </>
        )}
        <div onClick={props.closePanel} className='close-icn'>
          <Close />
        </div>
      </div>
    </div>
  );
};

CallPreviewPanel.propTypes = {
  closePanel: PropTypes.func.isRequired,
  call: PropTypes.object,
};

export default CallPreviewPanel;
